import type { FC } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useViewerData } from '@xing-com/hub';

import * as Styled from './header-actions.styles';
import { HeaderMoreActions } from './header-more-actions/header-more-actions';

export const HeaderActions: FC = () => {
  const { pageContext } = usePageContext();
  const { isLoggedIn } = useLoginState();
  const { data } = useViewerData();

  const viewerIsInsider = pageContext.insiderPageName === data?.user?.pageName;

  const hideFollowButton =
    isLoggedIn && pageContext.isInsiderPage && viewerIsInsider;

  return (
    <>
      {!hideFollowButton ? <Styled.FollowButton /> : null}
      <HeaderMoreActions />
    </>
  );
};
